export default {
  participant: {}
}
